import React,{useEffect} from 'react'
import Reacticon from './react.svg'
import Reduxicon from './redux.svg'
//import Framermotion from './Framermotion.png'
//import Material from './material.svg'
import Js from './js.svg'
import Cpp from './cpp.svg'
import Java from './java.svg'
import Python from './python.svg'
import css from './css.svg'
import Html from './html.svg'
import Firebase from './firebase.svg'
import { motion, useAnimation } from 'framer-motion'
import {useInView} from 'react-intersection-observer'

const divVariants = {
    hidden: {
        opacity:0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren:0.4
        }
    }
}

const skillVariants = {
    hidden: {
        x:'-50vw',
        opacity:0
    },
    visible: {
        x:0,
        opacity: 1,
        transition: {
            duration: 1,
            ease: 'easeOut',
        }
    }
}

const iconVariants = {
    hidden: {
        opacity:0,
        scale:0.9
    },
    visible: {
        opacity:1,
        scale:1,
        transition: {
            duration: 0.5
        }
    }
}

function Skills() {
    const controls = useAnimation()
    const {ref, inView} = useInView({triggerOnce:true})

    useEffect(() => {
        if (inView) {
            controls.start("visible")
        }
        if(!inView){
            controls.start("hidden")
        }
    }, [controls,inView])
    
    return (
        <>
            <motion.div
                ref={ref}
                variants={divVariants}
                initial="hidden"
                animate={controls}
                className="skill-container">
                <motion.div
                    ref={ref}
                    variants={skillVariants}
                    className="heading">
                    Skillset
                </motion.div>

                <div
                    className="icon-container">
                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Cpp} alt="cpp"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            C++
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Java} alt="java"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Java
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Python} alt="python"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Python
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Html} alt="html"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            HTML
                        </div>
                    </motion.div>
                    
                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={css} alt="css"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            CSS
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Js} alt="js"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            javaScript
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Reacticon} alt="reacticon"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            React
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Reduxicon} alt="reduxicon"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Redux
                        </div>
                    </motion.div>

                    {/* <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Framermotion} alt="framermotion"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Framer Motion
                        </div>
                    </motion.div>

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Material} alt="material"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Material-UI
                        </div>
                    </motion.div> */}

                    <motion.div
                        ref={ref}
                        variants={iconVariants}
                        whileHover={{
                            scale: 1.1,
                        }}
                        className="icon-width">
                        <div>
                            <img src={Firebase} alt="firebase"
                                className="skill-icon"/>
                        </div>
                        <div className="icon-heading">
                            Firebase 
                        </div>
                    </motion.div>

                </div>
            </motion.div>
        </>
    )
}

export default Skills
